/**
 * Licensed Materials - Property of ROOTCLOUD
 * THIS MODULE IS "RESTRICTED MATERIALS OF ROOTCLOUD"
 * (c) Copyright ROOTCLOUD Inc. 2021 All Rights Reserved
 *
 * The source code for this program is not published or
 * otherwise divested of its trade secrets
 */
import user from "@/api/other/user";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { registerMicroApps } from "qiankun";
import { _local, logoutKey } from "@/utils/storage";
import { application } from "@/api/other/sysManage";
import store from "@/store";

const getDefaultState = () => ({
  token: getToken(),
  name: "",
  avatar: "",
  userInfo: {},
  company: "",
  companyList: [],
  tenantId: "",
  userId: "",
  useOrgId: "",
  roles: "",
  isSystem: false,
  permissions: [],
  title: {},
  layoutConfigExtendData: {},
  infoData: {},
  isTenant: false,
  tenantData: {}
});

const state = getDefaultState();

const mutations = {
  RESET_STATE: state => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_COMPANY: (state, company) => {
    state.company = company;
  },
  SET_COMPANY_LIST: (state, companyList) => {
    state.companyList = companyList;
  },
  SET_TENANT_ID: (state, tenantId) => {
    state.tenantId = tenantId;
  },
  SET_USERID: (state, userId) => {
    state.userId = userId;
  },
  SET_USE_ORG_ID: (state, tenantId) => {
    state.useOrgId = tenantId;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_ISSYSTEM: (state, isSystem) => {
    state.isSystem = isSystem;
  },
  SET_ISTENANT: (state, isTenant) => {
    state.isTenant = isTenant;
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions;
  },
  SET_MIACAPPDIC: (state, mircAppDic) => {
    state.mircAppDic = mircAppDic;
  },
  SET_TITLE: (state, data) => {
    state.title = data;
  },
  SET_ORGID: (state, data) => {
    state.orgId = data;
  },
  SET_LAYOUT_CONFIG_EXTENED_DATA: (state, layoutConfigExtendData) => {
    state.layoutConfigExtendData = layoutConfigExtendData;
  },
  SET_INFO_DATA: (state, data) => {
    state.infoData = data;
  },
  SET_TENANT_INFO: (state, data) => {
    state.tenantData = data;
  }
};

function registerMircApp(appData) {
  const apps = [];
  for (const key in appData) {
    const item = appData[key];
    apps.push({
      name: key,
      entry: item["url"],
      container: "#mircApp",
      activeRule: `#/${key}`,
      props: {
        store
      }
    });
  }

  registerMicroApps(apps);
}
const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password, passwordEncrypted = false } = userInfo;
    return new Promise((resolve, reject) => {
      user
        .login({ username: username.trim(), password, passwordEncrypted })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      user
        .getMircAppConfig()
        .then(response => {
          const { data } = response;
          const appData = JSON.parse(data);
          console.log("data", data);

          /*
           * 本地测试代码
           *  const appData = {
           *    "scim-edm-web": { url: "http://ui.rootcloudapp.com:9529", bodyClass: "custom-theme" },
           *  };
           */
          // const appData = {
          //   'scim-edm-web': { url: 'http://ui.rootcloudapp.com:9529', bodyClass: 'custom-theme' },
          //   'scim-bigdata-app': { url: 'http://scim-bigdata-app-web.bdn-scim-dev.rootcloudapp.com' }
          // };
          if (appData) {
            commit("SET_MIACAPPDIC", appData);
          }
          registerMircApp(appData);
          user
            .getInfo(state.token)
            .then(response => {
              const { data } = response;
              if (!data) {
                return reject("Verification failed, please Login again.");
              }
              commit("SET_TOKEN", "common-has-login");
              setToken("common-has-login");
              commit("SET_INFO_DATA", data);
              commit("SET_TENANT_ID", data.tenantId);
              commit("SET_ROLES", data.roles);
              commit("SET_ISSYSTEM", data.isSystemAdmin);
              commit("SET_ISTENANT", data.isTenantAdmin);
              commit("SET_PERMISSIONS", data.permissions);
              commit("SET_COMPANY", data.orgName);
              commit("SET_ORGID", data.orgId || []);
              commit("SET_USE_ORG_ID", data.tenantId);
              const { user } = data;
              commit("SET_USERINFO", user);
              commit("SET_NAME", user.displayName);
              resolve(data);
            })
            .catch(error => {
              reject(error);
            });
        })
        .catch(err => {
          console.log("子应用获取失败", err);
          user
            .getInfo(state.token)
            .then(response => {
              const { data } = response;
              if (!data) {
                return reject("Verification failed, please Login again.");
              }
              commit("SET_TOKEN", "common-has-login");
              setToken("common-has-login");
              commit("SET_INFO_DATA", data);
              commit("SET_TENANT_ID", data.tenantId);
              commit("SET_ROLES", data.roles);
              commit("SET_ISSYSTEM", data.isSystemAdmin);
              commit("SET_ISTENANT", data.isTenantAdmin);
              commit("SET_PERMISSIONS", data.permissions);
              commit("SET_COMPANY", data.orgName);
              commit("SET_ORGID", data.orgId || []);
              commit("SET_USE_ORG_ID", data.tenantId);
              const { user } = data;
              commit("SET_USERINFO", user);
              commit("SET_NAME", user.displayName);
              resolve(data);
            })
            .catch(error => {
              reject(error);
            });
        });
    });
  },
  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      user
        .logout(state.token)
        .then(() => {
          // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
          this.dispatch("tagsView/delAllViews", null, { root: true });
          _local.set(logoutKey, true);
          removeToken(); // must remove  token  first
          // reset visited views and cached views
          commit("RESET_STATE");
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken(); // must remove  token  first
      commit("RESET_STATE");
      resolve();
    });
  },
  // 获取系统logo及名称
  getTitle({ commit, state }) {
    return new Promise((resolve, reject) => {
      application
        .getTitle()
        .then(res => {
          if (res.code === 200) {
            const data = {
              headerTitle: res.data.applicationName,
              fileUrl: res.data.applicationIcon,
              adminId: res.data.adminId
            };
            commit("SET_TITLE", data);
            commit("SET_TENANT_INFO", res.data);
          }
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
